import { tagAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';

var _a = createMultiStyleConfigHelpers(tagAnatomy.keys), definePartsStyle = _a.definePartsStyle, defineMultiStyleConfig = _a.defineMultiStyleConfig;
var baseStyle = defineStyle(function (props) {
    props.colorScheme; props.size;
    return {
        container: {
            borderRadius: "16px",
            fontSize: "10px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "12px",
            letterSpacing: "0.3px",
            textTransform: "uppercase",
        },
    };
});
var variantPending = definePartsStyle({
    container: {
        bg: "neutrals.200",
        color: "neutrals.700",
    },
});
var variantSuccess = definePartsStyle({
    container: {
        bg: "success.200",
        color: "success.900",
    },
});
var variantWarning = definePartsStyle({
    container: {
        bg: "warning.200",
        color: "warning.900",
    },
});
var variantError = definePartsStyle({
    container: {
        bg: "error.200",
        color: "error.800",
    },
});
var sizeLarge = defineStyle({
    container: {
        p: "8px 10px 8px 8px",
        height: "28px",
    },
    label: {
        marginLeft: "8px",
    },
});
var sizeSmall = defineStyle({
    container: {
        p: "2px 8px",
        height: "16px",
    },
    label: {
        marginLeft: "4px",
    },
});
var tagTheme = defineMultiStyleConfig({
    baseStyle: baseStyle,
    sizes: {
        large: sizeLarge,
        small: sizeSmall,
    },
    variants: {
        pending: variantPending,
        success: variantSuccess,
        warning: variantWarning,
        error: variantError,
    },
    defaultProps: {
        variant: "pending",
        size: "large",
    },
});

export { tagTheme };
//# sourceMappingURL=tag.js.map
